import { createSlice } from "@reduxjs/toolkit";

interface ModalInterface {
  timestamp: number | null;
}

const initialState: ModalInterface = {
  timestamp: null, //Date.now(),
};

const countdownSlice = createSlice({
  name: "countdown",
  initialState,
  reducers: {
    resetCountDown: (state) => {
      state.timestamp = Date.now();
    },
  },
});

export const { resetCountDown } = countdownSlice.actions;

export default countdownSlice.reducer;
